import React from 'react';
import {
  Box,
  Button,
  Card,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import riftWoman from "../assets/campos-de-parques-eolicos.jpg";
import { Link as RouterLink } from 'react-router-dom';


// Imagem de exemplo (substitua pelo seu caminho real)
const serviceImage = riftWoman;

// Componente estilizado para o item de serviço
const ServiceItem = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3.5),
  paddingBottom: theme.spacing(3),
  borderBottom: `1px solid rgba(255, 255, 255, 0.1)`,
  '&:last-child': {
    borderBottom: 'none',
    marginBottom: 0,
    paddingBottom: 0,
  },
}));

// Componente estilizado para o título do serviço
const ServiceTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  '&::before': {
    content: '""',
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    marginRight: theme.spacing(1.5),
  },
}));

function Services() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const services = [
    {
      title: "Installation & Deployment",
      description: "Complete implementation of underground and aerial fiber optic systems — including directional drilling, duct installation, and cable pulling — tailored to your project’s needs."
    },
    {
      title: "Infrastructure Maintenance",
      description: "Ongoing support and technical maintenance to ensure the durability and reliability of your fiber network over time."
    },
    {
      title: "Network Expansion & Upgrades",
      description: "We help expand and modernize existing infrastructure with scalable solutions and the latest construction techniques."
    }
  ];

  return (
    <Card
      elevation={0}
      sx={{
        p: { xs: 3, md: 5 },
        backgroundColor: 'transparent',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 4, md: 7.5 },
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.4)',
        maxWidth: 1500,
        mx: 'auto',
        my: 4,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 280 }}>
        <Typography 
          variant="body1" 
          sx={{ 
            fontWeight: 600, 
            mb: 2, 
            color: 'primary.main',
            letterSpacing: 1 
          }}
        >
          SERVICES
        </Typography>
        
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2.5,
            fontSize: { xs: 28, md: 36 },
            lineHeight: 1.2,
            color: '#ffffff'
          }}
        >
          Efficient and Reliable Fiber Infrastructure Construction
        </Typography>
        
        <Typography 
          variant="body1" 
          sx={{ 
            mb: 4, 
            color: 'rgba(255, 255, 255, 0.85)', 
            lineHeight: 1.6 
          }}
        >
          At Brothers Fiber, we specialize in the construction of fiber optic networks, delivering infrastructure that meets the highest standards of quality and performance. From groundwork to final delivery, we build the backbone of modern connectivity.
        </Typography>

        {services.map((service, index) => (
          <ServiceItem key={index}>
            <ServiceTitle 
              variant="h6"
              sx={{
                color: '#ffffff'
              }}
            >
              {service.title}
            </ServiceTitle>
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.75)', 
                lineHeight: 1.6,
                pl: 2.5
              }}
            >
              {service.description}
            </Typography>
          </ServiceItem>
        ))}
        
        <Box sx={{ mt: 5, display: 'flex', gap: 2, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
          <RouterLink to="/services">
            <Button 
            variant="contained" 
            color="primary" 
            size="large"
            sx={{
              borderRadius: 12,
              px: 4,
              py: 1.5,
              fontWeight: 600,
              fontSize: '1rem',
              backgroundColor: '#3AC3E3',
              boxShadow: '0 8px 20px rgba(58, 195, 227, 0.4)',
              '&:hover': {
                backgroundColor: '#2B8AC6',
                boxShadow: '0 12px 25px rgba(58, 195, 227, 0.5)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.3s ease'
            }}
            >
              Learn More
            </Button>
          </RouterLink>
        </Box>
      </Box>
      
      <Box
        sx={{
          flex: 1.2,
          minWidth: 260,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box
          component="img"
          src={serviceImage}
          alt="Technician installing fiber optics"
          sx={{
            width: '81%',
            height: 'auto',
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
            border: '1px solid rgba(255, 255, 255, 0.05)',
          }}
        />
      </Box>
    </Card>
  );
}

export default Services;